const HIDE_FOR_LANG_CODES = new Set(['DE', 'PL']);

export const FORCED_CURRENCY_CODE = 'CZK';

function normalizeLangCode(lang) {
    const raw = String(lang?.code ?? lang?.ref_code ?? lang ?? '')
        .trim()
        .toUpperCase()
        .replace('_', '-');

    return raw;
}

/** @param {object|string|null|undefined} lang */
export function shouldHideCurrencyConverter(lang) {
    const code = normalizeLangCode(lang);
    if (!code) {
        return false;
    }

    const base = code.split('-')[0];

    return HIDE_FOR_LANG_CODES.has(code) || HIDE_FOR_LANG_CODES.has(base);
}

/** @param {object|string|null|undefined} lang */
export function forcedCurrencyCodeForLang(lang) {
    return shouldHideCurrencyConverter(lang) ? FORCED_CURRENCY_CODE : null;
}

function isCzechLanguage(lang) {
    const code = normalizeLangCode(lang);
    if (!code) {
        return false;
    }

    return code === 'CS' || code.split('-')[0] === 'CS';
}

/**
 * @param {object|string|null|undefined} lang
 * @param {string|null|undefined} [currencyCode]
 */
export function skipsCurrencyConversion(lang, currencyCode) {
    if (shouldHideCurrencyConverter(lang)) {
        return true;
    }

    const currency = String(currencyCode ?? '').trim().toUpperCase();

    return isCzechLanguage(lang) && currency === FORCED_CURRENCY_CODE;
}

/**
 * @param {object|string|null|undefined} lang
 * @param {object|null|undefined} currency
 */
/** Prices come from GET /products?currency=… — never multiply client-side. */
export function displayConversionRate() {
    return 1;
}
